module.exports = __webpack_public_path__ + "assets/img/team-fill.c5a6813f.svg";